import React, { useEffect } from 'react'
import FormInput from './form-input/FormInput'
import {
  FieldValues,
  Path,
  PathValue,
  RegisterOptions,
  useWatch,
} from 'react-hook-form'
import {
  FORMAT_PATTERN,
  NAMESPACE,
  PhonePropTypes,
  REGEX,
  VALUE_CONSTANTS,
} from '../utils'

const PhoneInput = <T extends FieldValues>({
  name,
  label,
  disabled = false,
  placeholder = '',
  defaultValue = '',
  register,
  errors,
  validation,
  formatPattern = FORMAT_PATTERN.PHONE_INPUT,
  setValue,
  dataQaId,
  control,
  customStyles = {},
  isControlled = true,
  isHelperTextVisible,
  ...rest
}: PhonePropTypes<T>) => {
  const formatInput = (inputValue: string, pattern: string) => {
    const digits = inputValue?.replace('+1', '')?.replace(/\D/g, '')
    let formattedValue = ''
    let patternIndex = VALUE_CONSTANTS.ZERO
    let digitIndex = VALUE_CONSTANTS.ZERO
    while (digitIndex < digits?.length && patternIndex < pattern?.length) {
      if (pattern[patternIndex] === 'X') {
        formattedValue += digits[digitIndex]
        digitIndex++
      } else {
        formattedValue += pattern[patternIndex]
      }
      patternIndex++
    }

    return formattedValue
  }
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value
    const formattedValue = formatInput(inputValue, formatPattern)
    setValue?.(name, formattedValue as PathValue<T, Path<T>>)
  }

  const fieldValue = useWatch({
    control,
    name: name as Path<T>,
  })

  useEffect(() => {
    if (fieldValue) {
      const formattedValue = formatInput(fieldValue, formatPattern)
      if (fieldValue !== formattedValue) {
        setValue?.(name, formattedValue as PathValue<T, Path<T>>)
      }
    }
  }, [fieldValue])

  return (
    <FormInput
      name={name}
      label={label}
      disabled={disabled}
      errors={errors}
      placeholder={placeholder}
      // TODO: might need later
      // value={watch?.(name) || ''}
      // formatter={(val) => {
      //   if (!val) return ''
      //   const newVal = formatInput(val, formatPattern)
      //   return newVal
      // }}
      value={isControlled ? formatInput(fieldValue, formatPattern) : undefined}
      onChange={handleChange}
      defaultValue={defaultValue}
      register={register}
      dataQaId={dataQaId ?? ''}
      validation={
        {
          ...(validation ?? {}),
          pattern: {
            value: REGEX.PHONE_INPUT,
            message: label?.toLowerCase().includes('fax')
              ? NAMESPACE.INVALID_FAX_NUMBER
              : NAMESPACE.INVALID_PHONE_NUMBER,
          },
        } as RegisterOptions<T, Path<T>>
      }
      customStyles={{ ...customStyles }}
      isHelperTextVisible={isHelperTextVisible}
      {...rest}
    />
  )
}

export default PhoneInput
